"use client";

import { useState } from "react";
import AppImage from "@/components/ui/AppImage";

const templates = [
{
  id: "default",
  name: "Default",
  description: "Clean, versatile layout that works for any collection type. Perfect for modern collection rooms and minimalist displays.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8f8f9aa-1771515383417.png",
  imageAlt: "Default TapTale template showing clean layout with collectible photography and metadata",
  accent: "border-accent-cyan",
  badge: "Most Used"
},
{
  id: "modern",
  name: "Modern",
  description: "Bold, high-contrast design with large typography. Bold, magazine-style layout for contemporary art and collectibles.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea1703a7-1768043637150.png",
  imageAlt: "Modern TapTale template with bold typography and high-contrast design",
  accent: "border-accent-purple",
  badge: null
},
{
  id: "elegant",
  name: "Elegant",
  description: "Refined serif typography and soft tones. Museum-quality presentation for high-end authenticated pieces.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19e472b9d-1771515380906.png",
  imageAlt: "Elegant TapTale template with serif typography for fine art collections",
  accent: "border-accent-gold",
  badge: "Fan Favorite"
},
{
  id: "immersive",
  name: "Immersive",
  description: "Full-bleed photography with cinematic overlays. Mobile-first fullscreen experience for intimate viewing.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_165f5ad30-1771515382520.png",
  imageAlt: "Immersive TapTale template with full-bleed photography and cinematic overlays",
  accent: "border-accent-crimson",
  badge: "New"
},
{
  id: "scrapbook",
  name: "Scrapbook",
  description: "Warm, nostalgic layout with layered photos and handwritten-style annotations. Nostalgic aesthetic for vintage memorabilia and retro collections.",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ebf35d6c-1771515381378.png",
  imageAlt: "Scrapbook TapTale template with layered photos and nostalgic design",
  accent: "border-accent-emerald",
  badge: null
}];


export default function TemplatesShowcase() {
  const [active, setActive] = useState("default");
  const current = templates.find((t) => t.id === active)!;

  return (
    <section className="py-24 md:py-32 px-6 md:px-8 bg-bg-secondary" aria-label="Viewer templates">
      <div className="max-w-container mx-auto">
        <div className="mb-12">
          <span className="font-mono text-[11px] text-accent-crimson uppercase tracking-[0.3em] block mb-4">
            Viewer Templates
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight text-white mb-4">
            Five stunning ways
            <br />
            <span className="italic text-gray-400">to tell your story.</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-md">
            Every collection has a personality. Choose the template that matches yours, or switch anytime — no re-cataloging required.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Template Selector */}
          <div className="lg:col-span-4 space-y-2">
            {templates.map((tmpl) =>
            <button
              key={tmpl.id}
              onClick={() => setActive(tmpl.id)}
              className={`w-full text-left p-4 rounded-2xl border transition-all duration-300 ${
              active === tmpl.id ?
              `bg-bg-card ${tmpl.accent} border-opacity-100` :
              "border-white/5 hover:border-white/15 hover:bg-bg-card/50"}`
              }>
              
                <div className="flex items-center justify-between mb-1">
                  <span className={`font-medium text-sm ${active === tmpl.id ? "text-white" : "text-gray-400"}`}>
                    {tmpl.name}
                  </span>
                  {tmpl.badge &&
                <span className="font-mono text-[9px] text-accent-gold uppercase tracking-wider border border-accent-gold/30 px-2 py-0.5 rounded-full">
                      {tmpl.badge}
                    </span>
                }
                </div>
                {active === tmpl.id &&
              <p className="text-gray-500 text-xs leading-relaxed">
                    {tmpl.description}
                  </p>
              }
              </button>
            )}
          </div>

          {/* Preview */}
          <div className="lg:col-span-8">
            <div className="rounded-2xl overflow-hidden img-zoom border border-white/8 card-offset-shadow">
              <AppImage
                src={current.image}
                alt={current.imageAlt}
                width={900}
                height={600}
                className="w-full h-72 md:h-96 object-cover" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

}